import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Card } from "react-bootstrap";
import {
  getAwardceremonyById,
  updateAwardceremony,
} from "../../../../services/AwardceremonyService";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

const EditAwardceremonyForm = () => {
  const [awardceremony, setAwardceremony] = useState({
    label: "",
    value: "",
    description: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  // Fetch awardceremony data when component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getAwardceremonyById(id);
        setAwardceremony(data);
      } catch (error) {
        console.error("Error fetching awardceremony:", error);
      }
    };
    fetchData();
  }, [id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // Send the form data to the server
    try {
      await updateAwardceremony(id, {
        label: awardceremony.label,
        value: awardceremony.value,
        description: awardceremony.description,
      });
      // Show success toast notification
      toast.success("Award Ceremony updated Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 2 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/awardceremonies");
      }, 3000);
    } catch (error) {
      console.error("Error in awardceremony update:", error);
      toast.error("Failed to Update awardceremony!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    console.log(`Field Name: ${name}, Field Value: ${value}`); // Debugging
    setAwardceremony({ ...awardceremony, [name]: value });
  };

  const handleTypeChange = (option) => {
    setAwardceremony({ ...awardceremony, type: option.value });
  };

  const handleQuaterChange = (option) => {
    setAwardceremony({ ...awardceremony, quater: option.value });
  };

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col xs={12}>
              <h4>Edit Award Ceremony</h4>
              {awardceremony ? (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3 mt-3">
                    <Col md={4}>
                      <Form.Group controlId="label">
                        <Form.Label>Label</Form.Label>
                        <Form.Control
                          type="text"
                          name="label"
                          value={awardceremony.label || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="value">
                        <Form.Label>Value</Form.Label>
                        <Form.Control
                          type="text"
                          name="value"
                          value={awardceremony.value || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="description">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          type="text"
                          name="description"
                          className="form-control"
                          placeholder="text"
                          value={awardceremony.description || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "20px" }}>
                    <div className="d-flex">
                      <Button className="me-2" variant="primary" type="submit">
                        Save Changes
                      </Button>
                      <Button
                        className="btn-danger"
                        variant="warning"
                        href="/settings/awardceremonies"
                      >
                        Cancel
                      </Button>
                    </div>
                  </Row>
                </Form>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </div>
      </Card>
      <ToastContainer />
    </>
  );
};

export default EditAwardceremonyForm;
